import src from '../assets/fairway365.png';
import { imageLogo } from './imageLogo';

/**
 * Fairway 365 — wide wordmark: white "FAIRWAY" + green "365" on a solid dark
 * grey (#484848) plate. The supplied artwork has no alpha, and the white ink
 * depends on that dark ground, so the plate cannot be keyed out — on light
 * surfaces the mark reads as a dark badge rather than a floating wordmark.
 * The plate's corners are softened by the registry's `roundedLogo`.
 *
 * Replace with a transparent, dark-ink variant when the designer supplies one.
 */
export const Fairway365Logo = imageLogo({
  src,
  width: 1000,
  height: 334,
  alt: 'Fairway 365',
});
